import { publicEnvConfig } from 'helpers/env';

export const recaptchaEnabled = publicEnvConfig.RECAPTCHA_ENABLED;

export const getRecaptchaVersionParam = (version) => `v${version}`;

export const isRecaptchaVersion = (version, routerQuery) =>
	routerQuery?.recaptcha === getRecaptchaVersionParam(version);

export const getRecaptchaV3Token = async (action) => {
	const siteKey = publicEnvConfig.RECAPTCHA_V3_SITE_KEY;
	if (siteKey) {
		return window?.grecaptcha?.enterprise?.execute(siteKey, { action });
	}
	return null;
};
